import React from 'react';

type FiveStarRatingProps = {
  rating: number;
};

/**
 * Shows a five-star rating for given score.
 *
 * Half-stars are shown when the score is between two integers (but at least 0.1 above the next
 * lower integer).
 */
export const FiveStarRating: React.FunctionComponent<FiveStarRatingProps> = props => {
  return (
    <div>
      {Array.from({ length: 5 }).map((_, index) => (
        <i
          className={`${index < Math.floor(props.rating) ? 'ic-rating-filled' : index < props.rating - 0.1 ? 'ic-rating-half' : 'ic-rating-empty'}`}
          key={index}
        />
      ))}
    </div>
  );
};
